import React, { useState } from 'react';
import { ButtonIcon } from '@hz-design-system/web-ui';

import trackEvent from '../../utils/trackEvent';
import { BUNDLE_COLLAPSE_FAQ } from '../../constants/events';

import Classes from './Faq.module.scss';

const Faq = (props: { question: string; answer: string }) => {
  const { question, answer } = props;

  const [isCollapsed, setCollapsed] = useState(true);

  const toggleCollapse = () => {
    if (isCollapsed) {
      trackEvent({
        eventAction: BUNDLE_COLLAPSE_FAQ,

        eventLabel: String(question).substring(0, 100),
      });
    }
    setCollapsed(!isCollapsed);
  };

  const buttonIconSvg = () => (isCollapsed ? 'arrow-down-regular' : 'arrow-up-regular');

  return (
    <div className={Classes.root}>
      <div className={Classes.headWrap} onClick={toggleCollapse} role="button">
        <div className={Classes.question}>{question}</div>
        <ButtonIcon name={buttonIconSvg()} />
      </div>
      {!isCollapsed && <div className={Classes.body}>{answer}</div>}
    </div>
  );
};

export default Faq;
